export default __webpack_public_path__ + "static/media/icon-heart.200574fc.svg";